import Vue from 'vue'
import { QUOTE_PACKAGE_PARAM, QUOTE_PACKAGE_PARAM_GENERAL, QUOTE_PACKAGE_GENERAL, QUOTE_PACKAGE_PLANS, QUOTE_PACKAGE_PARAM_PLAN_LOADING, QUOTE_PACKAGE_PARAM_PLAN_SUCCESS, QUOTE_PACKAGE_PARAM_PLAN_FAIL, QUOTE_PACKAGE_APPLICANT, QUOTE_PACKAGE_FIRE_RISK, QUOTE_PACKAGE_PAYMENT, QUOTE_PACKAGE_ADJ_INIT, QUOTE_PACKAGE_ADJ_CANCEL, QUOTE_PACKAGE_ADJ, QUOTE_PACKAGE_RECALCULATE_LOADING, QUOTE_PACKAGE_RECALCULATE_SUCCESS, QUOTE_PACKAGE_RECALCULATE_FAIL } from '@/store/types'
import { commitPkgPremium } from './quote'
import { formatServerTimeFormat } from '@/utils/date'

export const pkg = {
  [QUOTE_PACKAGE_PARAM](state, data) {
    // Note: Key - ignoreValue is reserved
    if (data) {
      const formatData = data
      let ignoreValue = data.ignoreValue
      if (ignoreValue === undefined) {
        ignoreValue = false
      }
      Object.keys(formatData).forEach(function (key) {
        if (key !== 'ignoreValue') {
          const arr = formatData[key]
          if (arr) {
            if (Array.isArray(arr)) {
              // Make it so that its value - label (easier to search)
              arr.map(obj => {
                if (!ignoreValue) {
                  obj.label = obj.value + ' - ' + obj.label
                }
              })
            }
            // Initially was using the Object.assign below
            // But due to vue js reactive caveats, we will use Vue.set instead
            Vue.set(state.quotation.packageParam, key, arr)
          }
        }
      })
      // Object.assign(state.quotation.packageParam, formatData)
    }
  },
  [QUOTE_PACKAGE_PARAM_GENERAL](state) {
    state.quotation.packageParam.generalLoaded = true
  },
  [QUOTE_PACKAGE_PARAM_PLAN_LOADING](state) {
    state.quotation.packageParam.plans.init = 0
    state.quotation.packageParam.plans.initErr = []
    state.quotation.packageParam.plans.limitsText = []
    state.quotation.packageParam.plans.plans = []
  },
  [QUOTE_PACKAGE_PARAM_PLAN_SUCCESS](state, data) {
    state.quotation.packageParam.plans.limitsText = data.limitsText
    state.quotation.packageParam.plans.plans = data.plans
    state.quotation.packageParam.plans.init = 1
    state.quotation.packageParam.plans.initErr = []
  },
  [QUOTE_PACKAGE_PARAM_PLAN_FAIL](state, data) {
    state.quotation.packageParam.plans.init = 2
    state.quotation.packageParam.plans.limitsText = []
    state.quotation.packageParam.plans.plans = []
    state.quotation.packageParam.plans.initErr = []
    if (data && data.length > 0) {
      state.quotation.packageParam.plans.initErr = data
    }
  },
  [QUOTE_PACKAGE_GENERAL](state, data) {
    if (data) {
      state.quotation.commonForm.product = data.product
      state.quotation.commonForm.scheme = data.scheme
      state.quotation.commonForm.acceptDate = data.acceptDate
      state.quotation.commonForm.startDate = data.startDate
      state.quotation.commonForm.endDate = data.endDate
      state.quotation.commonForm.campaign = data.campaign
      state.quotation.commonForm.promotion = data.promotion

      // Reset plans init (always get new plans after 1st screen)
      state.quotation.packageParam.plans.init = 0
    }
  },
  [QUOTE_PACKAGE_PLANS](state, data) {
    state.quotation.packageForm.planNo = data

    // Save premium info to commonInfo
    const plan = state.quotation.packageParam.plans.plans.find(x => x.planNo === data)
    if (plan && plan.premium) {
      commitPkgPremium(state, plan.premium)

      // For package, dont have to do the following mutation. The flow is different from the rest of the products
      // Flag reviewPlan init as 1 (as it wont trigger recalculate when coming back from the next page)
      // state.quotation.packageParam.reviewPlan.init = 1
    } else {
      commitPkgPremium(state, null)
    }
  },
  [QUOTE_PACKAGE_APPLICANT](state, data) {
    if (data) {
      // Applicant Information
      const { applicant } = state.quotation.commonForm

      applicant.appSalutation = data.appSalutation
      applicant.appName = data.appName
      applicant.appNricPassport = data.appNricPassport
      if (data.appDob) {
        applicant.appDob = formatServerTimeFormat(data.appDob)
      }
      applicant.appGender = data.appGender
      applicant.appOccupation = data.appOccupation
      applicant.appEmail = data.appEmail
      applicant.appMobileNo = data.appMobileNo
      applicant.appTelNo1 = data.appTelNo1
      applicant.appTelNo2 = data.appTelNo2
      applicant.appPostalCode = data.appPostalCode
      applicant.appAdd1 = data.appAdd1
      applicant.appAdd2 = data.appAdd2
      applicant.appAdd3 = data.appAdd3
      applicant.appAdd4 = data.appAdd4
      applicant.mailAdd = data.mailAdd
      applicant.mailPostalCode = data.mailPostalCode
      applicant.mailAdd1 = data.mailAdd1
      applicant.mailAdd2 = data.mailAdd2
      applicant.mailAdd3 = data.mailAdd3
      applicant.mailAdd4 = data.mailAdd4
      applicant.coyName = data.coyName
      applicant.coyName2 = data.coyName2
      applicant.coyRocUen = data.coyRocUen
      applicant.coyNature = data.coyNature
    }
  },
  [QUOTE_PACKAGE_FIRE_RISK](state, data) {
    // Fire Risk
    const { fireForm } = state.quotation
    fireForm.riskAdd = data.riskAdd
    fireForm.riskAdd1 = data.riskAdd1
    fireForm.riskAdd2 = data.riskAdd2
    fireForm.riskAdd3 = data.riskAdd3
    fireForm.riskAdd4 = data.riskAdd4
    fireForm.riskPostalCode = data.riskPostalCode
  },
  [QUOTE_PACKAGE_PAYMENT](state, data) {
    state.quotation.commonForm.paytMode = data.paytMode
    state.quotation.commonForm.paytCCNo = data.paytCCNo
    state.quotation.commonForm.paytCCName = data.paytCCName
    state.quotation.commonForm.paytCCType = data.paytCCType
    state.quotation.commonForm.paytCCExpMth = data.paytCCExpMth
    state.quotation.commonForm.paytCCExpYr = data.paytCCExpYr
    state.quotation.commonForm.paytCCCvv = data.paytCCCvv
  },
  [QUOTE_PACKAGE_ADJ_INIT](state, data) {
    Vue.set(state.quotation.packageForm, 'siAdjustment', data)
    state.quotation.packageParam.reviewPlan.adjInit = true
  },
  [QUOTE_PACKAGE_ADJ_CANCEL](state) {
    // Reset Plan
    state.quotation.packageForm.planNo = null

    // Reset Premium
    commitPkgPremium(state, null)

    // Reset Discount Adjustment
    state.quotation.commonForm.adjDiscount = null

    // Reset Adjustment
    state.quotation.packageForm.siAdjustment = null
    state.quotation.packageParam.reviewPlan.adjInit = false
  },
  [QUOTE_PACKAGE_ADJ](state, data) {
    if (state.quotation.packageForm.siAdjustment && state.quotation.packageForm.siAdjustment[data.id]) {
      Vue.set(state.quotation.packageForm.siAdjustment, data.id, data.value)
    }
    // Check Against 0 Value
    if (state.quotation.packageForm.siAdjustment && state.quotation.packageForm.siAdjustment[data.id] === 0) {
      Vue.set(state.quotation.packageForm.siAdjustment, data.id, data.value)
    }
  },
  [QUOTE_PACKAGE_RECALCULATE_LOADING](state) {
    state.quotation.packageParam.reviewPlan.init = 0
    state.quotation.packageParam.reviewPlan.initErr = []
  },
  [QUOTE_PACKAGE_RECALCULATE_SUCCESS](state, data) {
    state.quotation.packageParam.reviewPlan.init = 1
    state.quotation.packageParam.reviewPlan.initErr = []
    commitPkgPremium(state, data)
  },
  [QUOTE_PACKAGE_RECALCULATE_FAIL](state, data) {
    state.quotation.packageParam.reviewPlan.init = 2
    if (data && data.length > 0) {
      state.quotation.packageParam.reviewPlan.initErr = data
    }
    // Reset Premium
    commitPkgPremium(state, null)
  }
}
